import { acceptHMRUpdate, defineStore } from 'pinia'
import timeService from '@/services/remainingTime.service'

export const useTimeStore = defineStore({
  id: 'timeStore',
  state: () => ({
    time: ''
  }),
  setup () {},
  actions: {
    getTimeList () {
      return timeService.getTimeList().then(
        response => {
          this.time = response.data
          return response
        }
      )
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTimeStore, import.meta.hot))
}
